import { useEffect, useRef } from "react";
import useReveal from "@/hooks/useReveal";

const VIDEO_SRC =
  "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/cmpv2q26_Odysseas%20Baptism_file.mp4";

export default function VideoSection() {
  const ref = useReveal();
  const videoRef = useRef(null);

  // Browsers block autoplay-with-sound until the visitor interacts with the page.
  // So: start playing immediately (muted), and unmute on the FIRST user interaction.
  useEffect(() => {
    const unmute = () => {
      const v = videoRef.current;
      if (v) {
        v.muted = false;
        v.volume = 1;
        v.play().catch(() => {});
      }
      window.removeEventListener("pointerdown", unmute);
      window.removeEventListener("keydown", unmute);
      window.removeEventListener("touchstart", unmute);
      window.removeEventListener("scroll", unmute);
    };
    window.addEventListener("pointerdown", unmute, { once: true });
    window.addEventListener("keydown", unmute, { once: true });
    window.addEventListener("touchstart", unmute, { once: true });
    window.addEventListener("scroll", unmute, { once: true });
    return () => {
      window.removeEventListener("pointerdown", unmute);
      window.removeEventListener("keydown", unmute);
      window.removeEventListener("touchstart", unmute);
      window.removeEventListener("scroll", unmute);
    };
  }, []);

  return (
    <section
      className="relative py-24 sm:py-32 lg:py-40 px-6"
      data-testid="video-section"
    >
      <div ref={ref} className="reveal max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <p className="label-eyebrow">A little film</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#4A5346] mt-6">
            Our story so far
          </h2>
        </div>

        <div
          className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] shadow-[0_24px_60px_rgba(143,160,146,0.18)] bg-[#F2EFE9]"
          data-testid="video-frame"
        >
          <video
            ref={videoRef}
            src={VIDEO_SRC}
            autoPlay
            loop
            muted
            playsInline
            controls
            controlsList="nodownload noremoteplayback noplaybackrate"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
            preload="auto"
            className="w-full h-auto aspect-video object-cover bg-black select-none"
          />
        </div>
      </div>
    </section>
  );
}
